export let NavigationMenuPositionerCssVars = /*#__PURE__*/function (NavigationMenuPositionerCssVars) {
  /**
   * The available width between the trigger and the edge of the viewport.
   * @type {number}
   */
  NavigationMenuPositionerCssVars["availableWidth"] = "--available-width";
  /**
   * The available height between the trigger and the edge of the viewport.
   * @type {number}
   */
  NavigationMenuPositionerCssVars["availableHeight"] = "--available-height";
  /**
   * The anchor's width.
   * @type {number}
   */
  NavigationMenuPositionerCssVars["anchorWidth"] = "--anchor-width";
  /**
   * The anchor's height.
   * @type {number}
   */
  NavigationMenuPositionerCssVars["anchorHeight"] = "--anchor-height";
  /**
   * The coordinates that this element is anchored to. Used for animations and transitions.
   * @type {string}
   */
  NavigationMenuPositionerCssVars["transformOrigin"] = "--transform-origin";
  /**
   * The fixed width of the positioner element.
   * @type {number}
   */
  NavigationMenuPositionerCssVars["positionerWidth"] = "--positioner-width";
  /**
   * The fixed height of the positioner element.
   * @type {number}
   */
  NavigationMenuPositionerCssVars["positionerHeight"] = "--positioner-height";
  return NavigationMenuPositionerCssVars;
}({});